import { useEffect, useState } from "react";
import ControlledBadge from "../elements/ControlledBadge";
import ButtonComponent from "../elements/ButtonComponent";
import StoreSelectModal from "../storeSelectModal/StoreSelectModal";
import { axiosPrivate } from "../../api/axios";
import { CORE_GET_COMMON_FILE } from "../../api/apiClient";
import { useNavigate } from "react-router-dom";
import { IoLocationSharp } from "react-icons/io5";
import { LuPhone } from "react-icons/lu";
import StarNewMeta from "./StarNewMeta";
import Link from "../elements/Link";
import ImageComponent from "../elements/ImageComponent";
import ModalComponents from "../modals/ModalComponents";
import { toast } from "react-toastify";

const ShopsDetailsCard = ({
  result,
  isInUserForm,
  openFunc,
  onSetStore,
  formNo,
  setFormNo,
  hasButtonShop,
  setEnteredUser,
  enteredUser,
}: any) => {
  const [storeInfoModalOpen, setStoreInfoModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [imSure, setImSure] = useState(false);
  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");

  const [base64Image, setBase64Image] = useState<any>(undefined);
  const [logoLoading, setLogoLoading] = useState(false);

  const user_state = localStorage.getItem("user_state");
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const fetchImage = async () => {
    setLogoLoading(true);
    try {
      const response = await axiosPrivate.get(
        CORE_GET_COMMON_FILE(result?.logo_uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );
      if (response?.status >= 200 && response.status < 300) {
        setBase64Image(response?.data?.data?.url);
        setLogoLoading(false);
      }
    } catch (error) {
      setLogoLoading(false);
      console.error("Error fetching image data:", error);
    }
  };

  useEffect(() => {
    fetchImage();
  }, [result?.logo_uid]);

  const openStoreSelect = () => {
    setStoreInfoModalOpen(true);
    setModalType("SelectStore");
  };

  const closeModal = () => {
    setStoreInfoModalOpen(false);
    setModalType("");
    setImSure(false);
    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("overflow-hidden");
    }
  };

  return (
    <div className="bg-white w-full h-full border-2 border-gray-100 shadow-button_sm_hover rounded-lg p-5 flex flex-col xs:gap-3 justify-between">
      <div className="flex justify-between items-center">
        <div className="flex">
          <div>
            <ImageComponent
              loading={logoLoading}
              src={base64Image}
              alt="shops logo"
              className="w-16 h-16 rounded-lg"
            />
          </div>
          <div className="flex flex-col justify-between mr-3">
            <p className="text-BodyText/16/Medium text-gray-900">
              {result?.name}
            </p>
            <div className="flex items-center">
              <IoLocationSharp className="text-primary-600" size={18} />
              <span className="text-BodyText/14/Regular text-gray-900 mr-2">
                {result.province_name}
              </span>
              <span className="text-BodyText/14/Regular text-gray-400 ">
                , {result.city_name}
              </span>
            </div>
          </div>
        </div>
        <div
          className="p-2 shadow-modal bg-white rounded-lg cursor-pointer"
          onClick={() => {
            onSetStore(
              result?.name,
              result?.telephone_number,
              result?.phone_number,
              base64Image
            );
            openFunc(true);
          }}
        >
          <LuPhone className="text-primary-600" size={22} />
        </div>
      </div>
      <div className="rounded-lg bg-primary-50 py-3 px-6">
        <div className="flex">
          <StarNewMeta rate={result.rate} />
          <div>
            <p className="text-BodyText/12/Bold text-gray-900">
              <span className="text-BodyText/14/Light text-gray-400">5</span> /{" "}
              {result.rate}
            </p>
            <p className="text-BodyText/14/Light text-gray-700">
              از {result.count_comments} نظر
            </p>
          </div>
        </div>
        <div className="flex items-center overflow-auto">
          {result?.product_groups?.length !== 0 &&
            result?.product_groups?.map((product_group: any, index: number) => (
              <div key={index}>
                <ControlledBadge
                  label={product_group?.name}
                  color="primary"
                  size="small"
                  className={"whitespace-nowrap"}
                />
              </div>
            ))}
        </div>
      </div>
      <div
        about="bottom"
        className="flex item-center flex-col xs:flex-row justify-between"
      >
        <div className="flex justify-end w-full">
          <a
            title={`${result?.name}/وامسی`}
            href={`/shops/shopdetails/${result?.store_uid}/${result?.name}`}
          >
            <ButtonComponent variant="outlined">جزئیات فروشگاه</ButtonComponent>
          </a>
          {isInUserForm && (
            <ButtonComponent
              onClick={
                !access_token
                  ? () => setIsLoginOpen(true)
                  : user_state === "VERIFIED"
                  ? openStoreSelect
                  : () => {
                      toast.info("لطفا ثبت نام خود را کامل نمایید.");
                      navigate("/fa/user-auth");
                    }
              }
              variant="filled"
              className="mr-2"
            >
              انتخاب فروشگاه
            </ButtonComponent>
          )}
        </div>
        {storeInfoModalOpen && (
          <StoreSelectModal
            telephone_number={result?.telephone_number}
            name={result?.name}
            phone_number={result?.phone_number}
            address={result?.address}
            onClose={closeModal}
            modalType={modalType}
            setModalType={setModalType}
            province_name={result?.province_name}
            city_name={result?.city_name}
            setImSure={setImSure}
            imSure={imSure}
            store_uid={result?.store_uid}
            formNo={formNo}
            setFormNo={setFormNo}
          />
        )}
        {isLoginOpen && (
          <ModalComponents
            onClose={() => setIsLoginOpen(false)}
            setEnteredUser={setEnteredUser}
          />
        )}
      </div>
    </div>
  );
};

export default ShopsDetailsCard;
